module.exports = __webpack_public_path__ + "static/media/Multipurpose_Template_1920x1080px.bbd02634.jpeg";